import { Injectable } from '@angular/core';
import { SearchType } from 'src/app/shared/models/search-type';

@Injectable({
    providedIn: 'root',
})
export class AllianceConfigurationService {
    getChargesURLBySearchType(searchType: string): string {
        return searchType === SearchType.awb ? '/search-awb/details' : '/search-flight/details';
    }
}
